export const LOGGER_LEVEL_INFO = 'INFO'
export const LOGGER_LEVEL_ERROR = 'ERROR'
export const OPERATING_COMPANY_DVS = 5
